import i18n from "./i18n";
import type { Player } from "../types";

/**
 * Chi fa parte della rosa operativa: giocatori non ospiti con status
 * "active". Tutti gli altri status (inactive, injured, suspended, archived)
 * valgono come "fuori rosa": il giocatore resta in squadra con il suo
 * storico, ma non compare tra i convocabili, non riceve i sondaggi e non
 * puo' rispondere dall'area giocatore. La stessa regola vale lato DB
 * (link pubblico, solleciti, notifiche filtrano su status = 'active').
 */
export function isSquadPlayer(p: Pick<Player, "is_guest" | "status">): boolean {
  return !p.is_guest && p.status === "active";
}

export function isOutOfSquad(p: Pick<Player, "is_guest" | "status">): boolean {
  return !p.is_guest && p.status !== "active";
}

export function isEvaluatingGuest(p: Pick<Player, "is_guest" | "tryout_status">): boolean {
  return p.is_guest && (p.tryout_status || "evaluating") === "evaluating";
}

export function playerStatusLabel(status: string): string {
  const key = `players:status.${status}`;
  return i18n.exists(key) ? (i18n.t(key) as string) : status;
}

// Reparti della rosa, nell'ordine in cui si leggono in campo.
const ROLE_GROUPS: Array<{ key: string; roles: string[] }> = [
  { key: "goalkeepers", roles: ["POR"] },
  { key: "defenders", roles: ["TD", "DC", "TS"] },
  { key: "midfielders", roles: ["MED", "CC", "TRQ", "ED", "ES"] },
  { key: "forwards", roles: ["ATT", "SP"] },
];

export function groupByRole<T>(rows: T[], roleOf: (row: T) => string | null | undefined) {
  const known = ROLE_GROUPS.flatMap((g) => g.roles);
  return [
    ...ROLE_GROUPS.map((g) => ({ key: g.key, rows: rows.filter((r) => g.roles.includes(roleOf(r) || "")) })),
    { key: "unassigned", rows: rows.filter((r) => !known.includes(roleOf(r) || "")) },
  ].filter((g) => g.rows.length > 0);
}
